module.exports = __webpack_public_path__ + "static/media/machine.e56f86f1.jpeg";